import { motion } from 'framer-motion';
import PricingCard from './PricingCard';

export default function PricingGroup({ group, lang, index }) {
  const tx = (o) => o?.[lang] || o?.en;
  return (
    <motion.section
      id={group.id}
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-80px' }}
      transition={{ duration: 0.7 }}
      className="py-14">
      <div className="text-center mb-12">
        <span className="text-xs font-medium tracking-[0.3em] uppercase text-primary">0{index + 1}</span>
        <h2 className="font-inter font-black text-3xl md:text-4xl tracking-[-0.02em] text-foreground mt-2 mb-3">{tx(group.title)}</h2>
        <p className="text-muted-foreground max-w-2xl mx-auto">{tx(group.subtitle)}</p>
      </div>
      <div className="grid md:grid-cols-3 gap-6">
        {group.packs.map((p) => <PricingCard key={p.name.en} pack={p} lang={lang} from={group.from} />)}
      </div>
    </motion.section>
  );
}